import React from 'react'
import { BasicStyledComponent, DSCompareDeal } from 'shared-definitions/types'
import styles from './CompareDeal.module.css'
import clsx from 'clsx'
import RWButton from '../buttons/RWButton'
import ArrowShare from 'shared-svg/ArrowShare.svg'
import ScoreRing from './ScoreRing'
import AppImage from './AppImage'
import { msrpFormat } from 'shared-code/format'
import SplitterLine from './SplitterLine'

interface CompareDealProps extends DSCompareDeal, BasicStyledComponent {}

export const CompareDeal: React.FC<CompareDealProps> = ({
  className,
  title,
  score,
  msrp,
  image,
  badges,
  button,
}) => (
  <article className={clsx(styles.container, className)}>
    <div className={styles.body}>
      {image && <AppImage sizes="300" image={image} layout="responsive" />}
      {badges.length > 0 && (
        <div className={styles.badges}>
          <AppImage
            image={badges[0]}
            className={styles.badge}
            imageClassName={styles.badgeImage}
            layout="raw"
            sizes="40"
          />
        </div>
      )}
      {score && <ScoreRing className={styles.score} score={score} />}
      <div className={styles.description}>
        <h4 className={styles.title}>{title}</h4>
        {msrp && (
          <>
            <SplitterLine className={styles.splitter} />
            <div className={styles.msrp}>{msrpFormat(msrp)}</div>
          </>
        )}
      </div>
      <RWButton className={styles.seeMore} variant="secondary" size="medium" pLink={button.pLink}>
        {button.label}
        <ArrowShare className={styles.seeMoreArrow} />
      </RWButton>
    </div>
  </article>
)

export default CompareDeal
